import React from "react";
import PropTypes from "prop-types";
import ListboxSelect from "./listbox-select";
import NumericInput from "./numeric-input";

const defaultOptions = [
  {
    label: "Days",
    value: "days",
  },
  {
    label: "Weeks",
    value: "weeks",
  },
  {
    label: "Months",
    value: "months",
  },

  {
    label: "Years",
    value: "years",
  },
];

const RollingDateInput = ({ onChange, value = "", options, disabled = false }) => {
  const unitOptions = options || defaultOptions;
  const tempCount = value.split("-")[0] || null;
  const tempUnit = value.split("-")[1] || null;

  const handleChange = (count, unit) => {
    onChange(`${count}-${unit}`);
  };

  return (
    <div className="et--rolling-date">
      <NumericInput
        aria-label="Time count"
        className="et--rolling-date-number"
        value={tempCount || ""}
        onChange={(count) => handleChange(count, tempUnit)}
        disabled={disabled}
        allowZero={false}
      />
      <ListboxSelect
        label="Time units"
        placeholder="Select..."
        className="et--rolling-date-unit"
        onChange={(unit) => handleChange(tempCount, unit.value)}
        value={unitOptions.find((option) => option.value === tempUnit)}
        options={unitOptions}
        disabled={disabled}
      />
    </div>
  );
};

RollingDateInput.propTypes = {
  /**
   * onChange callback function
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Value should be a string in the format [count]-[unit] (e.g. 2-months) where
   * the unit is one of the options in the options array and the count is a number
   */
  value: PropTypes.string,
  /**
   * Options for the units. If none are provided, it will default to Days, Weeks, Months, and Years
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  /**
   * Should disable both NumericInput and unit dropdown
   */
  disabled: PropTypes.bool,
};

export default RollingDateInput;
